// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__V7Dwj","nav":"Sidebar_nav__GO6Q+","active":"Sidebar_active__e4szr"};